<app-header class="cashout-header"  [pageTitle]="pageTitle" (back)="goBack()"></app-header>
@if (showWidget) {
  <div class="chatbot-icon" (click)="openChatBot()">
    <ion-icon name="chatbubbles"></ion-icon>
  </div>
}
<ion-content>
  @if (cashoutData$ | async; as cashoutData) {
    <div class="cashout-page" data-clarity-mask="true">
      <!-- Enhance Cash Out Page UI to Distinguish Available and Pending Balances start-->
      @if (userBalance$ | async; as userBalance) {
        <div class="cc-wrapper">
          <div class="cashout-card">
            <div class="info-text">
              <img class="cc-info" src="assets/icon/information.png" alt="info-icon">
              <p>{{ "cashout.immediately" | translate }}</p>
            </div>
            <p class="cc-amount">
              {{ isPayPalCurrencyINRSignal() ? paypalCurrencySymbol : currencySymbol }}{{(isPayPalCashoutSignal() ? isGBPValueSignal() : (userBalance?.preferred_currency?.withdraw_amount ?? userBalance?.withdraw_amount)) ?? 0  }}
            </p>
            <p class="g-dot cc-amount-status">
              {{ "cashout.Available" | translate }}
            </p>
          </div>
          @if ((userBalance?.winning_balance > 0 || userBalance?.preferred_currency?.winning_balance > 0) && (userBalance?.winning_balance != userBalance?.withdraw_amount || userBalance?.preferred_currency?.winning_balance != userBalance?.preferred_currency?.withdraw_amount)) {
            <div class="cashout-card">
              <div class="info-text">
                <img class="cc-info" src="assets/icon/information.png" alt="info-icon">
                <p>{{ "cashout.Yourpending" | translate }}</p>
              </div>
              <p class="cc-amount">
                {{currencySymbol}}{{
                userBalance?.preferred_currency?.winning_balance ??
                userBalance?.winning_balance ?? 0 }}
              </p>
              <p class="o-dot cc-amount-status">{{ "cashout.BalanceIncl" | translate }}</p>
              <p class="cc-amount-status mute-text">{{ "cashout.Balances" | translate }}</p>
            </div>
          }
        </div>
      }
      <!-- Enhance Cash Out Page UI to Distinguish Available and Pending Balances end-->
      @if (cashOutLatestStatus$ | async; as recentStatus) {
        <div>
          <ion-row class="paypal-withdraw">
            <ion-col class="left-sec">
              <div class="paypal-withdraw-content">
                <div class="paypal-icon">
                  @if (recentStatus?.name_type == 'PayPal') {
                    <img src="assets/images/paypal-p.png" class="pp-img" />
                  }
                  @if (recentStatus?.name_type == 'Convert to Credit') {
                    <img src="assets/icon/dark_credit.svg"
                      class="pp-img" />
                  }
                  @if (recentStatus?.name_type == 'Donate to Charity') {
                    <img src="assets/icon/color.svg" class="pp-img" />
                  }
                </div>
                <div class="paypal-desc">
                  <label class="pp-title">
                    {{
                      recentStatus?.name_type === "PayPal"
                        ? ("cashout-status.PayPal" | translate)
                        : recentStatus?.name_type === "Convert to Credit"
                        ? ("cashout-status.Credits" | translate)
                        : ("cashout-status.Charity" | translate)
                    }}
                  </label>
                  <label class="pp-subtitle" [class.clickable]="recentStatus?.status === 'declined'"
                  (click)="recentStatus?.status === 'declined' && onDeclinedClick()">{{ getTranslatedText(recentStatus?.detail_status) | capitalizeFirst }}</label>
                </div>
              </div>
            </ion-col>
            <ion-col class="right-sec">
              <label class="pp-price">
                {{ isLangINR ? paypalCurrencySymbol : currencySymbol}}{{ isLangINR ? recentStatus?.value : (recentStatus?.preferred_currency?.value ?? recentStatus?.value) | displayCurrency }}
              </label>
              <!--  <label class="pp-price"> {{ currencySymbol }}{{ recentStatus?.value | displayCurrency }}</label> -->
          <div class="pp-status" [ngClass]="{
              'processed-chip': recentStatus?.status == 'processed'
            }">
                <ion-label> {{ ('cashout.' + recentStatus?.status) | translate }}</ion-label>
              </div>
            </ion-col>
          </ion-row>
          @if (isCashoutMoreThan1$ | async) {
            <div class="cashout-status-wrap">
              <p class="cashout-status" (click)="openCashoutStatus()">{{ "cashout.History" | translate }}</p>
            </div>
          }
        </div>
      }
      <h1 class="sub-heading">{{ "cashout.would" | translate }}</h1>
      <ion-row class="home-select-cashout">
        <ion-col class="destination-options" (click)="selectOption('convert')"
          [ngClass]="typeOfCashout === 'convert' ? 'selected-slide' : ''">
          <ion-card class="card-specs" [ngClass]="typeOfCashout === 'convert' ? 'selected-card' : ''">
            <div class="checbox-area">
              <ion-checkbox color="secondary" [checked]="typeOfCashout === 'convert'"></ion-checkbox>
            </div>
            <div class="convert-to-credit-img"><img src="assets/icon/convert_to_credit.png" /></div>
            <p class="convert-to-credit">
              {{ "cashout.Convert" | translate }} <br />{{ "cashout.to credit" | translate }}
            </p>
          </ion-card>
        </ion-col>
        <ion-col class="destination-options" (click)="selectOption('donation')"
          [ngClass]="typeOfCashout === 'donation' ? 'selected-slide' : ''">
          <ion-card class="card-specs" [ngClass]="typeOfCashout === 'donation' ? 'selected-card' : ''">
            <div class="checbox-area">
              <ion-checkbox color="secondary" [checked]="typeOfCashout === 'donation'"></ion-checkbox>
            </div>
            <div class="convert-to-credit-img"><img src="assets/icon/donate-to-charity.jpg" /></div>
            <p class="convert-to-credit">
              {{ "cashout.Donate" | translate }} <br />
              {{ "cashout.to charity" | translate }}
            </p>
          </ion-card>
        </ion-col>
        <ion-col class="destination-options" (click)="selectOption('paypal')"
          [ngClass]="typeOfCashout === 'paypal' ? 'selected-slide' : ''">
          <ion-card class="card-specs" [ngClass]="typeOfCashout === 'paypal' ? 'selected-card' : ''">
            <div class="checbox-area">
              <ion-checkbox color="secondary" [checked]="typeOfCashout === 'paypal'"></ion-checkbox>
            </div>
            <div class="convert-to-credit-img"><img src="assets/icon/cashout-paypal@3x.jpg" /></div>
            <p class="convert-to-credit">
              {{ "cashout.PayPal" | translate }} <br />
              {{ "cashout.cashout" | translate }}
            </p>
          </ion-card>
        </ion-col>
      </ion-row>
      @if (typeOfCashout === 'donation') {
        <div>
          <p class="donate-content">
            {{
            cashoutData?._charity_explained && cashoutData?._charity_explained[selectedLanguage]
            ? cashoutData?._charity_explained[selectedLanguage]
            : cashoutData?.charity_explained
            }}
          </p>
          <h2 class="Football-heading">
            {{
            cashoutData?._charity_name && cashoutData?._charity_name[selectedLanguage]
            ? cashoutData?._charity_name[selectedLanguage]
            : cashoutData?.charity_name
            }}
          </h2>
          <div class="Football-img-content">
            <div class="fb-img">
              <img class="FBB-img" src="assets/icon/FBB.png" alt="fbb-IMG" />
            </div>
            <div class="fb-des">
              <p class="Football-content">
                {{
                cashoutData?._charity_details && cashoutData?._charity_details[selectedLanguage]
                ? cashoutData?._charity_details[selectedLanguage]
                : cashoutData?.charity_details
                }}
                <!-- FBB uses the power of football to inspire young people from disadvantaged backgrounds to achieve their goals. -->
                <span class="Learn-more" (click)="learnMoreAboutCharity()"> {{ "cashout.Learn more" | translate }} </span>
              </p>
            </div>
          </div>
          <h2 class="amount-heading">{{ "cashout.Enter amount" | translate }}</h2>
          <h2 class="cash-sub-heading">{{ "cashout.Cash" | translate }}</h2>
          <div class="input-wrapper">
            <div class="input-euro-symbol">{{ currencySymbol }}</div>
            <ion-input class="input-field" inputmode="decimal" (keypress)="numericOnly($event)" [value]="quantity" min="0"
              (ionBlur)="blurOnCharity($event)" (ionInput)="setDonationValue($event?.target.value, cashoutData)"
              placeholder="0.00">
            </ion-input>
          </div>
          @if (userBalance$ | async; as userBalance) {
            <div>
              @if (errorMsg) {
                <span class="withdraw-balance">{{ errorMsg }}</span>
              }
            </div>
          }
          <h2 class="cash-sub-heading">{{ "cashout.Total" | translate }}</h2>
          <div class="input-wrapper input-margin">
            <div class="input-euro-symbol">{{ currencySymbol }}</div>
            <ion-input class="input-field" value="{{ cashoutData?.charity_multiplier * cashValue | displayCurrency }}"
            readonly></ion-input>
          </div>
          <div>
            <p class="max-donation">
              {{ "cashout.donation" | translate }}
              <span class="max-donation-value">{{ currencySymbol
                }}{{cashoutData?.int_charity_max_limit?.[preferredCurrency] ?
              cashoutData?.int_charity_max_limit?.[preferredCurrency] : cashoutData?.charity_max_limit}}</span>
            </p>
          </div>
        </div>
      }
      @if (typeOfCashout === 'convert') {
        <div class="convert-to-cash-content">
          <p>
            {{
            cashoutData?._credit_explained && cashoutData?._credit_explained[selectedLanguage]
            ? cashoutData?._credit_explained[selectedLanguage]
            : cashoutData?.credit_explained
            }}
          </p>
          <h2 class="amount-heading-c2c">{{ "cashout.Enter amount" | translate }}</h2>
          <h2 class="cash-subheader">{{ "cashout.Cash" | translate }}</h2>
          <div class="input-wrapper input-margin">
            <div class="input-euro-symbol">{{ currencySymbol }}</div>
            <ion-input inputmode="decimal" class="input-field" (keypress)="numericOnly($event)" [value]="quantityCredit"
              (ionBlur)="blurOnCredit($event)"
              (ionInput)="cashConversion($event?.target.value, cashoutData?.credit_multiplier, cashoutData)"
              placeholder="0.00">
            </ion-input>
          </div>
          @if (userBalance$ | async; as userBalance) {
            <div>
              @if (errorMsg) {
                <span class="withdraw-balance">{{ errorMsg }}</span>
              }
            </div>
          }
          <h2 class="cash-subheader">
            {{ "cashout.Credit" | translate }} x {{ cashoutData?.credit_multiplier }} {{ "cashout.Multiplier" | translate }}
          </h2>
          <div class="input-wrapper credit-final-input">
            <div class="input-euro-symbol">{{ currencySymbol }}</div>
            <ion-input class="input-field" value="{{ cashoutData?.credit_multiplier * cashValue | displayCurrency }}"
              readonly>
            </ion-input>
          </div>
        </div>
      }
      @if (typeOfCashout === 'paypal') {
        <div class="paypal-content">
          <p>
            {{
            cashoutData?._Paypal_explained && cashoutData?._Paypal_explained[selectedLanguage]
            ? cashoutData?._Paypal_explained[selectedLanguage]
            : cashoutData?.Paypal_explained
            }}
          </p>
          <h1 class="subhead">{{ "cashout.email" | translate }}</h1>
          <p class="email-description">
            {{ "cashout.connected" | translate }}
            <a target="_blank" href="https://www.paypal.com/in/webapps/mpp/account-selection">{{
              "cashout.Create account" | translate
            }}</a>
          </p>
          <h1 class="paypal-detail-header">{{ "cashout.Email" | translate }}</h1>
          <div class="input-wrapper credit-final-input input-margin-paypal">
            <ion-input class="input-field" [ngModel]="email"
              [ngClass]="{ errorClass: isEmailValid === false && email != '' }" type="email"
            (ionInput)="setPayPalEmail($event?.target.value)" placeholder=" Email"></ion-input>
          </div>
          @if (!isEmailValid && email != '') {
            <div class="errorContainer">
              <span class="withdraw-balance">{{ "cashout.format" | translate }}{{ "cashout.@example" | translate }}</span>
            </div>
          }
          <h1 class="paypal-detail-header">{{ "cashout.Enter amount" | translate }}</h1>
          @if (isAlertSignal()){
            <!-- Alert Start -->
            <div color="light" class="warning-card">
              <div class="warning-content">
                <ion-icon name="alert-circle" class="warning-icon-1"></ion-icon>
                <span class="warning-text">
                  {{ "cashout.alert_msg" | translate }}
                </span>
              </div>
            </div>
            <!-- Alert End -->
            }
          <div class="input-wrapper credit-final-input">
            <div class="input-euro-symbol">{{ isPayPalCurrencyINRSignal() ? paypalCurrencySymbol : currencySymbol }}</div>
            <ion-input [ngClass]="{ errorClass: errorMsg }" class="input-field" min="3" (keypress)="numericOnly($event)"
              inputmode="decimal" [value]="quantityPayPal" (ionBlur)="blurOnPayPal($event)"
              (ionInput)="setPayPalCash($event?.target.value, cashoutData)" placeholder="0.00">
            </ion-input>
          </div>
          @if (userBalance$ | async; as userBalance) {
            <div class="errorContainer">
              @if (errorMsg) {
                <span class="withdraw-balance">{{ errorMsg }}</span>
              }
            </div>
          }
          <p class="minimum-payout" [innerHTML]="cashoutLowestMsg | safeHtml | translate"></p>
        </div>
      }
      @if (typeOfCashout === 'convert') {
        <ion-button size="small" expand="block" [disabled]="!creditConversion || !cashValue || processingCashOut"
          class="action-btn-large donation-btn" (click)="cashOutModal('conversion'); startSpinner()"
          >
          @if (!spinnerAnimation && proceed) {
            <span>{{ "cashout.Convert to credit" | translate }}</span>
          }
          @if (spinnerAnimation) {
            <div class="spinners">
              <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
              </mat-progress-spinner>
            </div>
          }
          @if (!proceed) {
            <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
          }
        </ion-button>
      }
      @if (typeOfCashout === 'donation') {
        <ion-button size="small" expand="block" [disabled]="!allowDonation || !cashValue || processingCashOut"
          class="action-btn-large donation-btn" (click)="cashOutModal('donation'); startSpinner()"
          >
          @if (!spinnerAnimation && proceed) {
            <span>{{ "cashout.Donate to charity" | translate }}</span>
          }
          @if (spinnerAnimation) {
            <div class="spinners">
              <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
              </mat-progress-spinner>
            </div>
          }
          @if (!proceed) {
            <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
          }
        </ion-button>
      }
      @if (typeOfCashout === 'paypal') {
        <ion-button size="small" expand="block" class="action-btn-large donation-btn"
      (click)="cashOutModal('paypal'); startSpinner()" [disabled]="
        !creditConversion ||
        !payPalCashValue ||
        email === '' ||
        !isEmailValid ||
        payPalCashValue < 3 ||
        processingCashOut
      ">
          @if (!spinnerAnimation && proceed) {
            <span>{{ "cashout.Cashout" | translate }}</span>
          }
          @if (spinnerAnimation) {
            <div class="spinners">
              <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
              </mat-progress-spinner>
            </div>
          }
          @if (!proceed) {
            <mat-icon [@bounceIn] class="tick-mark">done</mat-icon>
          }
        </ion-button>
      }
    </div>
  }
</ion-content>
